import api from './api';

export const getAllActive = async () => {
  try {
    const response = await api.get(`/sites/getAllActive`);
    return response.data;
  } catch (error) {
    console.error(
      'Error al obtener los usuarios:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};

export const getAllByActive = async (is_active = 1) => {
  try {
    const response = await api.get(`/sites/getAllByActive/${is_active}`);
    return response.data;
  } catch (error) {
    console.error(
      'Error al obtener las encuestas:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};

export const getSiteById = async id => {
  try {
    const response = await api.get(`/sites/getById/${id}`);
    // El backend regresa el site directamente, no un objeto { result, site }
    return response.data;
  } catch (error) {
    console.error(
      'Error al obtener el sitio:',
      error.response?.data || error.message
    );
    return null;
  }
};
export const updateSite = async (
  id,
  name,
  is_active,
  header_color,
  footer_color,
  domain_name
) => {
  try {
    const response = await api.put(`/sites/update/${id}`, {
      name,
      is_active,
      header_color,
      footer_color,
      domain_name
    });
    // El backend regresa { result: true/false }
    return response.data;
  } catch (error) {
    console.error(
      'Error al actualizar el sitio:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};

export const createSite = async (
  name,
  is_active,
  header_color,
  footer_color,
  domain_name
) => {
  try {
    const response = await api.post('/sites/create', {
      name,
      is_active,
      header_color,
      footer_color,
      domain_name
    });
    // El backend regresa { result: true/false, site }
    return response.data;
  } catch (error) {
    console.error(
      'Error al crear el sitio:',
      error.response?.data || error.message
    );
    return { result: false };
  }
};
